import { Tag } from "antd";

export const VersionTag = ({ entity }: { readonly entity: { readonly versionNumber: number } }) => (
  <Tag>v{entity.versionNumber}</Tag>
);
